var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.reference,staticClass:"welcome__illustration animated",class:_vm.reference,on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }